import { useTranslate } from '@repo/shared/hooks'
import { Card, CenterBox, Col, Icon, Typography } from '@repo/ui/components'
import { useRouter } from '@repo/shared/i18n/navigation'
import { useEffect } from 'react'
import { IQuickKycSuccessProps } from './quick-kyc.types'

export const QuickKycSuccess = (props: IQuickKycSuccessProps) => {
  const { mobileOrEmail } = props
  const { t } = useTranslate()
  const { replace } = useRouter()

  useEffect(() => {
    const timer = setTimeout(() => {
      replace('/dashboard')
    }, 5000)

    return () => clearTimeout(timer)
  }, [replace])

  return (
    <Card className='p-xl rounded-sm h-[240px]'>
      <CenterBox className='h-full'>
        <Col className='gap-md items-center'>
          <CenterBox className='bg-positive-surface-100/20 rounded-full'>
            <Icon
              name='CheckCircleGhost'
              className='size-full rounded-full'
              size='2xl'
              color='fill-positive-surface-100'
            />
          </CenterBox>

          <Typography
            size='lg'
            weight='bold'
            color='text-positive-surface-100'
            className='text-center'
          >
            {t('quickKyc_success_title', {
              mobileOrEmail,
            })}
          </Typography>
          <Typography
            size='xs'
            weight='regular'
            color='text-neutral-surface-60'
            className='text-center animate-[pulse_1s_ease-in-out_infinite]'
          >
            {t('quickKyc_success_description')}
          </Typography>
        </Col>
      </CenterBox>
    </Card>
  )
}
